<template>
  <b-modal
    ref="changeExpiration"
    centered
    size="md"
    title="Set new expiration date"
    hide-header-close
    scrollable
    footer-bg-variant=""
    @show="applyCurrentExpiry()"
    @hidden="unselectUser(), clearCurrentExpiry()">

    <b-form-group
      id="newDate"
      label="Expiration Date"
      label-for="newDate"
      class="w-100">
      <date-range-picker
        v-model="newDate"
        single-date-picker
        time-picker
        :min-date="new Date().toISOString()"
        :locale-data="{ firstDay: 1, format: 'DD.MM.YYYY' }"
        :ranges="false"
        class="w-100">
        <template v-slot:input="picker">
          <span v-if="dateIsSelected">
            {{ picker.startDate | moment("DD.MM.YYYY, HH:mm") }}
          </span>
          <span
            v-else
            class="text-muted no-select">Select date</span>
        </template>
      </date-range-picker>
    </b-form-group>

    <b-alert
      variant="light-info"
      show
      class="mb-8">
      <p class="font-size-lg mb-0">
        Select a new date for the user until which period he can continue to use his account. Also, if the user was disabled automatically and beyond the expiration date, the account will be automatically enabled
      </p>
    </b-alert>

    <div class="font-weight-bold mb-2">User Details</div>
    <b-list-group
      v-if="selectedUserId !== null"
      class="mb-0">
      <b-list-group-item class="d-flex align-items-center">
        User ID
        <b-badge
          variant="light"
          class="ml-auto font-size-xs">{{ selectedUser.code }}</b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Reseller ID
        <span class="ml-auto">{{ selectedUser.item_id }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Devices
        <span class="ml-auto">{{ selectedUser.devices }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Created
        <span class="ml-auto">{{ selectedUser.created | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Expiry
        <span class="ml-auto">{{ selectedUser.expiry | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('changeExpiration')">
          Cancel
        </b-button>
        <b-button
          variant="primary"
          size="md"
          class="ml-auto"
          :disabled="usersResponses('changeUserExpire') || !dateIsChanged"
          :class="{ 'no-events' : !dateIsChanged }"
          @click="changeUserExpiry(), hideModal('changeExpiration')">
          Save and Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { CHANGE_USER_EXPIRY, UNSELECT_USER } from '@/core/services/store/users.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'
import moment from 'moment'

export default {
  name: 'ModalChangeExpiration',
  data() {
    return {
      showModal,
      hideModal,
      moment,

      newDate: {
        startDate: null,
        endDate: null
      },
    }
  },
  computed: {
    ...mapGetters([
      'selectedUser',
      'selectedUserId',
      'usersResponses',
    ]),

    dateIsSelected() {
      return this.newDate.startDate !== null
    },

    dateIsChanged() {
      return this.newDate.startDate !== this.selectedUser.expiry
    },
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectUser() {
      this.$store.commit(UNSELECT_USER)
    },

    applyCurrentExpiry() {
      this.newDate.startDate = this.selectedUser.expiry
    },

    clearCurrentExpiry() {
      this.newDate.startDate = null
    },

    changeUserExpiry() {
      this.$store.dispatch(CHANGE_USER_EXPIRY, {
        id: this.selectedUserId,
        expiry: this.newDate.startDate
      })
    }
  }
}
</script>
